/**
 * 轻量 toast —— 复刻原站共享层的 `t.message(text, { duration = 2000 })`：
 * 往 body 追加一个节点、渲染 <div class="Ctbtco"><div class="MKDt1I">{text}</div></div>、
 * 淡入 300ms、停留 duration、淡出 300ms，然后卸载并移除节点。
 *
 * 原站用 gsap + 独立 react root；这里用纯 DOM + CSS 动画，效果一致且不引入额外依赖。
 */
import './toast.css';

const DEFAULT_DURATION = 2000;
const FADE = 300;

/** 同一时刻只保留一条，避免错误连发时堆叠 */
let current: { el: HTMLDivElement; timer: number } | null = null;

export function toast(text: string, duration: number = DEFAULT_DURATION) {
  if (typeof document === 'undefined') return;

  if (current) {
    window.clearTimeout(current.timer);
    current.el.remove();
    current = null;
  }

  const el = document.createElement('div');
  el.className = 'toast';
  el.setAttribute('role', 'status');
  const inner = document.createElement('div');
  inner.className = 'toastBody';
  inner.textContent = text;
  el.appendChild(inner);
  document.body.appendChild(el);

  // 触发淡入（下一帧再加 visible，保证 transition 生效）
  requestAnimationFrame(() => el.classList.add('isVisible'));

  const timer = window.setTimeout(() => {
    el.classList.remove('isVisible');
    window.setTimeout(() => el.remove(), FADE);
    current = null;
  }, duration);

  current = { el, timer };
}
